import { type CreateExternalBankAccountData } from '../../business-logic/interfaces/IExternalBankAccountRepository'
import { ExternalBankAccountTypes } from '../../entities/enums/ExternalBankAccountTypeEnum'

interface CreateExternalBankAccountPayload {
  name: string
  type: number
  data: Record<string, string>
  currency: number
  assignees: number[]
  gl_code?: string
}

// POST /api/v2/ap/company-payment-methods/ payload: `data` block varies by
// type, `currency` is a bare id, `assignees` is always present (empty for
// bank accounts), and `gl_code` is omitted when blank.
export const mapExternalBankAccountFormToPayload = (
  data: CreateExternalBankAccountData
): CreateExternalBankAccountPayload => {
  const typeData = (() => {
    switch (data.type) {
      case ExternalBankAccountTypes.CHECK:
        return { start_number: data.startNumber }
      case ExternalBankAccountTypes.ACH:
        return {
          bank_name: data.bankName,
          bank_routing_number: data.bankRoutingNumber,
          company_name: data.companyName,
          company_routing_number: data.companyRoutingNumber,
          company_tax_id: data.companyTaxId,
        }
      case ExternalBankAccountTypes.OTHER:
      default:
        return { description: data.description }
    }
  })()

  const glCode = data.glCode.trim()

  return {
    name: data.name,
    type: data.type,
    data: typeData,
    currency: data.currencyId,
    assignees: [],
    ...(glCode ? { gl_code: glCode } : {}),
  }
}
